export const DropDawnPlanIcon = () => (
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.571324 7.21484L6.99989 1.42913L13.4285 7.21484" stroke="#191B1F" />
  </svg>
);
